import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { IPackageHotel } from '@appTypes/redefined-types';
import { TranslatePipe } from '@ngx-translate/core';
import { StarsComponent } from '../stars/stars.component';

@Component({
  selector: 'app-hotel-card',
  imports: [MatIconModule, StarsComponent, TranslatePipe, DatePipe],
  templateUrl: './hotel-card.component.html',
  styleUrl: './hotel-card.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HotelCardComponent {
  hotel = input<IPackageHotel>();
}
